import PropTypes from 'prop-types';

import { BaseBlockType } from './common.types';

export const EmptyBlockPropType = PropTypes.shape(BaseBlockType);
